import React from 'react';
import { SimulationForm } from '../../components/Simulation';
import { InteractiveWrapper } from '../../components/Interface';
import { Simulation as SimulationTemplate } from '../../components/Templates'

export const Simulation = () => {
    return (
      <InteractiveWrapper 
        name='simulation'
        title="Simulation"
        template={SimulationTemplate}
        hasStyles={false}
        initFunction='initSimulation'
      >
        <SimulationForm />
      </InteractiveWrapper>
    )
}
